"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tagExists = exports.shouldLoadTags = exports.formatTags = exports.findMissingTag = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var formatTags = exports.formatTags = function formatTags(tags) {
  if (!Array.isArray(tags)) {
    return;
  }
  return tags.filter(function (element) {
    return _typeof(element) === 'object';
  }).map(function (element) {
    return _typeof(element.options) === 'object' ? Object.values(element.options) : element;
  }).flat();
};
var tagExists = exports.tagExists = function tagExists(tag, allTags) {
  var innerAllTags = [];
  if (!tag) {
    return true;
  }
  if (tag.length) {
    tag = tag[0];
  }
  allTags.forEach(function (element) {
    if (_typeof(element) === 'object') {
      if (_typeof(element.options) === 'object') {
        for (var value in element.options) {
          innerAllTags.push(element.options[value].value);
        }
      } else {
        innerAllTags.push(element.value);
      }
    }
  });
  return innerAllTags.includes(tag.value);
};
var shouldLoadTags = exports.shouldLoadTags = function shouldLoadTags(input, allTags) {
  if (!allTags) {
    return [];
  }
  return allTags.filter(function (i) {
    return i.label.toLowerCase().includes(input.toLowerCase());
  });
};
var findMissingTag = exports.findMissingTag = function findMissingTag(existingTags, newTags) {
  if (!existingTags || !newTags) {
    return [];
  }
  var existingValues = new Set(existingTags.map(function (tag) {
    return tag.value;
  }));
  return newTags.filter(function (tag) {
    return !existingValues.has(tag.value);
  });
};